module.exports = __webpack_public_path__ + "img/tableBlack.27250810.svg";